import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import Small from 'UIComponents/elements/Small';
import { H5, H7 } from 'UIComponents/elements/headings';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACCORDION_TITLE_CLASS_NAME = 'workflows-action-panel-category-title';

// The borders between categories should extend to the edges of the panel
const PANEL_PADDING = 32;

// Need these custom css to make the default accordion looks close to designs
const CategoryUIAccordionItem = styled(UIAccordionItem).withConfig({
  displayName: "CategoryAccordion__CategoryUIAccordionItem",
  componentId: "sc-1i92eqw-0"
})(["margin:0 ", "px;padding:0 ", "px;.", "{padding-left:0;& > *{display:flex;align-items:center;gap:12px;> *{position:relative;top:0;left:0;min-width:6px;}}}& + &{border-top:1px solid ", ";}"], -PANEL_PADDING, PANEL_PADDING, ACCORDION_TITLE_CLASS_NAME, GREAT_WHITE);
const CategoryAccordion = ({
  description,
  header,
  hasSearchText,
  icon,
  additionalContent,
  children,
  onOpenChange,
  showDescriptionOnExpand
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // This is to make sure that when there is a search text, the matching category accordion is expanded
  useEffect(() => {
    setIsOpen(hasSearchText);
  }, [hasSearchText]);
  return /*#__PURE__*/_jsx(CategoryUIAccordionItem, {
    animate: !hasSearchText,
    titleClassName: `${ACCORDION_TITLE_CLASS_NAME} m-all-0`,
    title: /*#__PURE__*/_jsx("div", {
      className: "display-flex align-center justify-between",
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        align: "center",
        itemLeft: icon,
        itemRight: additionalContent,
        children: showDescriptionOnExpand || !isOpen ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(H7, {
            role: "presentation",
            className: "m-bottom-0",
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: header
            })
          }), description && /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(UITruncateString, {
              className: "m-top-1",
              children: description
            })
          })]
        }) : /*#__PURE__*/_jsx(H5, {
          role: "presentation",
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(UITruncateString, {
            children: header
          })
        })
      })
    }),
    className: "p-y-3",
    open: isOpen,
    onOpenChange: ({
      target: {
        value
      }
    }) => {
      setIsOpen(value);
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(value);
    },
    contentClassName: "p-left-0",
    "data-test-id": "new-action-category",
    children: children
  });
};
export default CategoryAccordion;